/*!
 *  Copyright (c) 2024, Rahul Gupta and PREP Fetch contributors.
 *
 *  This Source Code Form is subject to the terms of the Mozilla Public
 *  License, v. 2.0. If a copy of the MPL was not distributed with this
 *  file, You can obtain one at http://mozilla.org/MPL/2.0/.
 *
 *  SPDX-License-Identifier: MPL-2.0
 */
const LEGAL_RESPONSE_CODES =  [ 200, 201, 204 ];
const LEGAL_EVENTS_RESPONSE_CODES =  [ 200 ];
const EVENTS_PROTOCOL = "prep";

export {
  LEGAL_RESPONSE_CODES,
  LEGAL_EVENTS_RESPONSE_CODES,
  EVENTS_PROTOCOL,
};
